module.exports = __webpack_public_path__ + "img/edit.7fe476f5.svg";